import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57e986a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reach-out" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reach-out__container" }, [
  /*#__PURE__*/_createElementVNode("p", null, "What does success look like for your project?"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:adisamicheal20@gmail.com",
    target: "_blank",
    rel: "noopener",
    role: "button"
  }, " Let's Talk ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}